import { Text } from "components/atoms/text/Text";
import { COLORS } from "styles/colors";
import styled from "styled-components";
import { calcRem } from "styles/theme";
import { useEffect, useState } from "react";
import * as s from "styles/ModalCommonStyled";
import { SCREEN_RECORDER_STATE } from "../headernav/HeaderNavBar";
import { ReactMediaRecorderHookProps } from "react-media-recorder";
import NormalConfirmModal from "components/templates/modal/small/confirm/normal";

export default function ScreenRecordingInit({
  setScreenRecorderOptions,
  setStatus,
}: {
  setScreenRecorderOptions: (
    screenRecorderOptions: ReactMediaRecorderHookProps
  ) => void;
  setStatus: (status: SCREEN_RECORDER_STATE | null) => void;
}) {
  const [isSupportMicrophone, setIsSupportMicrophone] = useState(true);
  const [withoutSound, setWithoutSound] = useState(true);
  //기기 마이크 지원 여부 체크
  const checkMicrophoneSupport = async () => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const hasMicrophone = devices.some(
        (device) => device.kind === "audioinput"
      );
      if (!hasMicrophone) {
        // console.log("마이크 지원 안함");
        setIsSupportMicrophone(false);
        setWithoutSound(true);
        return;
      }
      checkMicrophonePermission();
    } catch (error) {
      console.error("Error checking microphone support:", error);
      setIsSupportMicrophone(false);
      setWithoutSound(true);
    }
  };
  //마이크 권한 체크
  const checkMicrophonePermission = async () => {
    try {
      const permission = await navigator.permissions.query({
        name: "microphone" as PermissionName,
      });
      setIsSupportMicrophone(permission.state !== "denied");
      if (permission.state === "denied") {
        //console.log("마이크 권한 거부");
        setWithoutSound(true);
      }
    } catch (error) {
      console.error("Error checking microphone permission:", error);
      setIsSupportMicrophone(false);
      setWithoutSound(true);
    }
  };
  useEffect(() => {
    //기기 마이크 지원 여부 체크
    checkMicrophoneSupport();
  }, []);
  return (
    <NormalConfirmModal
      onConfirmCancel={() => {
        setStatus(null);
      }}
      onConfirm={() =>
        setScreenRecorderOptions({
          screen: true,
          audio: !withoutSound,
        })
      }
    >
      <TextWrapper>
        <Text fontSize={20} bold>
          Press "Yes" to start recording the screen.
        </Text>
        <br />
        <Text fontSize={18} color={COLORS.COMPANY}>
          - The maximum recording time is 5 minutes.
          <br />- Don't resize the window during recording.
        </Text>
        <br />
        {isSupportMicrophone && !withoutSound && (
          <Text fontSize={18} bold color={COLORS.RED}>
            <>
              - You must allow myDW to access your microphone for recording,
              <br />
              if your device supports a microphone.
            </>
          </Text>
        )}

        {isSupportMicrophone && (
          <>
            <br />
            <s.CheckInput style={{ justifyContent: "center" }}>
              <input
                type="checkbox"
                id="withsound"
                checked={withoutSound}
                onChange={() => {
                  setWithoutSound(!withoutSound);
                }}
                data-testid="blocks-screenrecorder-withsound-set-without-sound"
              />

              <Text fontSize={14}>
                <label htmlFor="withsound">Record without sound</label>
              </Text>
            </s.CheckInput>
          </>
        )}
      </TextWrapper>
    </NormalConfirmModal>
  );
}
export const TextWrapper = styled.div`
  text-align: center;
  padding: 20px 0;
  line-height: ${calcRem(28)};
`;
